import {Directive, ElementRef, Input, Renderer2, OnInit, OnChanges, SimpleChanges, Inject} from '@angular/core';
import {AuthFacade} from "../../../auth/facade/auth.facade";
import {HttpClient} from "@angular/common/http";
import * as _ from 'lodash'

declare var window: any;

@Directive({
  selector: '[appDynamicImage]',
  standalone: true,
  providers: [HttpClient]
})
export class DynamicImageDirective implements OnInit, OnChanges {

  @Input() dynamicSrc: string = '';
  // @Input() dynamicSrc: string = 'assets/images/loading-spinner-1.gif';
  @Input() imagePlacement: 'src' | 'background' = 'src';
  @Input() place: 'default' | 'charts' = 'default';
  @Input() disable: boolean = false;

  constructor(private elem: ElementRef, private renderer: Renderer2, private authFacade: AuthFacade,
              private httpClient: HttpClient) {
    // if(this.dynamicSrc){
    //   this.setSource(this.dynamicSrc);
    //   console.log(this.dynamicSrc);
    // }
  }

  ngOnInit() {
    if(this.dynamicSrc){
      this.setAsyncSource();
    }
    // this.setAsyncSource()
    if(this.place === "charts"){
      // this.setAsyncSource();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.firstChange) {
      if(changes['dynamicSrc'].currentValue){
        this.setAsyncSource()
      }
    }
  }

  setAsyncSource() {
    if(this.disable){
      this.setSource(this.dynamicSrc);
      return;
    }
    const isAssetsDirectory = (this.dynamicSrc && this.dynamicSrc.indexOf('assets/images/') !== -1)
    const userDetails = JSON.parse(this.authFacade.getLocalStorageData('userData'));
    if (userDetails && userDetails.accessToken && !isAssetsDirectory) {
      if(this.dynamicSrc !== 'unset'){
        if(this.dynamicSrc.indexOf('data:image') === -1){
          let x = _.cloneDeep(this.dynamicSrc)
          if(x.indexOf('95037854-7ae7-46f1-b6cc-9a67348ed73c.png')!== -1){
            console.log(x, this.elem);
          }
          this.httpClient.get(this.dynamicSrc, {responseType: 'blob'}).subscribe((res: any) => {
            let urlCreator = window.URL || window.webkitURL;
            let imageUrl = urlCreator.createObjectURL(res);
            this.setSource(imageUrl)
          })
        }else{
          this.setSource(this.dynamicSrc)
        }
      }else{
        this.setSource(this.dynamicSrc)
      }
    } else {
      this.setSource(this.dynamicSrc)
    }
  }

  setSource(src: string) {
    if (this.imagePlacement === 'src') {
      if (src) {
        this.renderer.setAttribute(this.elem.nativeElement, 'src', src);
        this.renderer.setStyle(this.elem.nativeElement, 'visibility', `visible`);
      }else{
        this.renderer.setStyle(this.elem.nativeElement, 'visibility', `hidden`);
      }
    } else {
      if(src === 'unset'){
        this.renderer.setStyle(this.elem.nativeElement, 'background-image', `unset`);
      }else{
        this.renderer.setStyle(this.elem.nativeElement, 'background-image', `url("${src}")`);
      }
      this.renderer.setStyle(this.elem.nativeElement, 'visibility', `visible`);
    }
  }

}
